// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PY5ioDyiOr48aM4MxjAh {
  display: flex;
  justify-content: center;
  align-items: stretch;
  position: sticky;
  top: -1px;
  height: var(--global-nav-height);
  background-color: var(--global-nav-bg-color);
  box-shadow:
    0 0.5em 0.5em 0 rgba(0, 0, 0, 0.16),
    0 -0.5em 0.5em 0 rgba(0, 0, 0, 0.16);
  padding: var(--space-2xs) 0;
  transition: var(--global-nav-transition);
  z-index: 1000;
  width: 100%;
}

.dGwCJf3mYuSiyGWr13qY {
  display: flex;
  gap: var(--space-2xs);
  width: 100%;
  justify-content: center;
}

.Jsqyy0kFss3iM0YyiRxN {
  display: none;
  padding: 0 var(--space-m);
  justify-content: flex-start;
  width: max-content;
  margin-top: calc(-1 * var(--space-3xs));
  margin-right: auto;
  transition: var(--global-nav-transition);
}

.GgNVO8vCuQZaDAYURklw .Jsqyy0kFss3iM0YyiRxN {
  display: flex;
}

.Jsqyy0kFss3iM0YyiRxN img {
  display: block;
  width: auto;
  height: 94%;
  object-fit: cover;
  object-position: left center;
  transition: var(--global-nav-transition);
}

.Jsqyy0kFss3iM0YyiRxN:active img {
  height: 96%;
}

.kqkpJU8qPIsJ2vUpScLr {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  align-items: center;
  transition: var(--global-nav-transition);
}

.F4ujAmYUox73Q2BnHryG {
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: 600;
  color: var(--text-lighter-color);
}

.GgNVO8vCuQZaDAYURklw .F4ujAmYUox73Q2BnHryG {
  display: none;
}

.kqkpJU8qPIsJ2vUpScLr a {
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: var(--global-nav-transition);
  color: var(--global-nav-link-color);
  font-size: var(--step--1);
  padding: var(--space-2xs) var(--space-s);
  transition: var(--global-nav-transition);
}

.J0T4aEd02ZDav5AVFNIu {
  display: none;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-decoration: none;
  font-size: var(--step-2);
  color: var(--global-nav-link-color);
  padding: var(--space-3xs) var(--space-xs);
  transition: var(--global-nav-transition);
}

.GgNVO8vCuQZaDAYURklw .J0T4aEd02ZDav5AVFNIu {
  display: flex;
}

.W5ydC0Capn9X38iCyyUn {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: var(--step-2);
  color: var(--global-nav-link-color);
  padding: var(--space-s) var(--space-xs);
  border: 0;
  outline: 0;
  background-color: transparent;
  margin: 0;
  cursor: pointer;
  transition: var(--global-nav-transition);
}

.kqkpJU8qPIsJ2vUpScLr a:hover,
.J0T4aEd02ZDav5AVFNIu:hover,
.W5ydC0Capn9X38iCyyUn:hover {
  color: var(--global-nav-link-color-hover);
}

.kqkpJU8qPIsJ2vUpScLr a:focus,
.J0T4aEd02ZDav5AVFNIu:focus,
.W5ydC0Capn9X38iCyyUn:focus {
  color: var(--global-nav-link-color-focus);
}

.kqkpJU8qPIsJ2vUpScLr a:active,
.J0T4aEd02ZDav5AVFNIu:active,
.W5ydC0Capn9X38iCyyUn:active {
  color: var(--global-nav-link-color-active);
}

.T3Pni6DossYKZRSaFoR_ {
  font-weight: 600;
  margin-left: var(--space-3xs);
}

.Kg7VHnK58ALI9cgitdCi {
  margin-right: var(--space-l);
}

.Rp8jTcpU1sjesdM_4aat {
  background-color: var(--primary-color);
  display: none;
  position: sticky;
  justify-content: center;
  align-items: stretch;
}

.SbHssD3nS2uF0_4LhVvZ {
  height: 4rem;
  background-color: var(--white-color);
  display: none;
  /* display: flex; */
  /* position: sticky; */
  justify-content: center;
  align-items: center;
}

.Rp8jTcpU1sjesdM_4aat a {
  color: var(--white-color);
  margin: 0;
  padding: var(--space-xs) var(--space-s);
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

.SbHssD3nS2uF0_4LhVvZ a {
  color: var(--white-color);
  margin: 0;
  padding: var(--space-xs) var(--space-s);
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

.qKq0K15EljkC7YtY1trK {
  position: fixed;
  margin-top: 0.8rem;
  top: var(--global-nav-height);
  left: 0;
  right: 0;
  z-index: 999;
}

.vf4PC6m9Q7rgi2YEP7b5 {
  margin-top: 0.8rem;
  top: var(--global-nav-height);
  left: 0;
  right: 0;
}

.miOdxh8RLqgnTaEtoCtw {
  position: fixed;
  z-index: 999;
}

.D6YwDzilEkC4mh5HOyuf {
  width: 50%;
  padding-left: 2rem;
  justify-content: flex-start;
  display: flex;
  z-index: 100;
  max-height: 0rem;
}

.KPh85AvIJKXiBfNNRkyR {
  width: 95%;
}

.SbHssD3nS2uF0_4LhVvZ.w8vnpG3ziJwwKPlURXRe {
  display: flex;
  justify-content: center;
  transition: var(--global-nav-transition);
}

@media (max-width: 740px) {
  .kqkpJU8qPIsJ2vUpScLr {
    display: none;
  }

  .W5ydC0Capn9X38iCyyUn {
    display: flex;
  }

  .dGwCJf3mYuSiyGWr13qY {
    display: flex;
    justify-content: space-between;
    width: 95%;
    padding-left: 1.5rem;
  }

  .Jsqyy0kFss3iM0YyiRxN {
    margin-left: -2rem;
  }

  .Rp8jTcpU1sjesdM_4aat.w8vnpG3ziJwwKPlURXRe {
    display: flex;

    transition: var(--global-nav-transition);
  }
}

@media (max-width: 650px) {
  .KPh85AvIJKXiBfNNRkyR {
    width: 90%;
  }

  .SbHssD3nS2uF0_4LhVvZ {
    height: 5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layout/GlobalNavContent.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,gCAAgC;EAChC,4CAA4C;EAC5C;;wCAEsC;EACtC,2BAA2B;EAC3B,wCAAwC;EACxC,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,yBAAyB;EACzB,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,mCAAmC;EACnC,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,mCAAmC;EACnC,uCAAuC;EACvC,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,SAAS;EACT,eAAe;EACf,wCAAwC;AAC1C;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,uCAAuC;EACvC,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,uCAAuC;EACvC,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;;IAEb,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".globalNav {\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  position: sticky;\n  top: -1px;\n  height: var(--global-nav-height);\n  background-color: var(--global-nav-bg-color);\n  box-shadow:\n    0 0.5em 0.5em 0 rgba(0, 0, 0, 0.16),\n    0 -0.5em 0.5em 0 rgba(0, 0, 0, 0.16);\n  padding: var(--space-2xs) 0;\n  transition: var(--global-nav-transition);\n  z-index: 1000;\n  width: 100%;\n}\n\n.globalNavContent {\n  display: flex;\n  gap: var(--space-2xs);\n  width: 100%;\n  justify-content: center;\n}\n\n.navLogo {\n  display: none;\n  padding: 0 var(--space-m);\n  justify-content: flex-start;\n  width: max-content;\n  margin-top: calc(-1 * var(--space-3xs));\n  margin-right: auto;\n  transition: var(--global-nav-transition);\n}\n\n.sticky .navLogo {\n  display: flex;\n}\n\n.navLogo img {\n  display: block;\n  width: auto;\n  height: 94%;\n  object-fit: cover;\n  object-position: left center;\n  transition: var(--global-nav-transition);\n}\n\n.navLogo:active img {\n  height: 96%;\n}\n\n.navMain {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: stretch;\n  align-items: center;\n  transition: var(--global-nav-transition);\n}\n\n.browse {\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-weight: 600;\n  color: var(--text-lighter-color);\n}\n\n.sticky .browse {\n  display: none;\n}\n\n.navMain a {\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-weight: 600;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: var(--global-nav-transition);\n  color: var(--global-nav-link-color);\n  font-size: var(--step--1);\n  padding: var(--space-2xs) var(--space-s);\n  transition: var(--global-nav-transition);\n}\n\n.navSearch {\n  display: none;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  text-decoration: none;\n  font-size: var(--step-2);\n  color: var(--global-nav-link-color);\n  padding: var(--space-3xs) var(--space-xs);\n  transition: var(--global-nav-transition);\n}\n\n.sticky .navSearch {\n  display: flex;\n}\n\n.navMenu {\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: var(--step-2);\n  color: var(--global-nav-link-color);\n  padding: var(--space-s) var(--space-xs);\n  border: 0;\n  outline: 0;\n  background-color: transparent;\n  margin: 0;\n  cursor: pointer;\n  transition: var(--global-nav-transition);\n}\n\n.navMain a:hover,\n.navSearch:hover,\n.navMenu:hover {\n  color: var(--global-nav-link-color-hover);\n}\n\n.navMain a:focus,\n.navSearch:focus,\n.navMenu:focus {\n  color: var(--global-nav-link-color-focus);\n}\n\n.navMain a:active,\n.navSearch:active,\n.navMenu:active {\n  color: var(--global-nav-link-color-active);\n}\n\n.navSubscribe {\n  font-weight: 600;\n  margin-left: var(--space-3xs);\n}\n\n.subscribeButton {\n  margin-right: var(--space-l);\n}\n\n.subNav {\n  background-color: var(--primary-color);\n  display: none;\n  position: sticky;\n  justify-content: center;\n  align-items: stretch;\n}\n\n.subNavSearch {\n  height: 4rem;\n  background-color: var(--white-color);\n  display: none;\n  /* display: flex; */\n  /* position: sticky; */\n  justify-content: center;\n  align-items: center;\n}\n\n.subNav a {\n  color: var(--white-color);\n  margin: 0;\n  padding: var(--space-xs) var(--space-s);\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.subNavSearch a {\n  color: var(--white-color);\n  margin: 0;\n  padding: var(--space-xs) var(--space-s);\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.stickySubNav {\n  position: fixed;\n  margin-top: 0.8rem;\n  top: var(--global-nav-height);\n  left: 0;\n  right: 0;\n  z-index: 999;\n}\n\n.stickySubNavSearch {\n  margin-top: 0.8rem;\n  top: var(--global-nav-height);\n  left: 0;\n  right: 0;\n}\n\n.subNavSearchFixed {\n  position: fixed;\n  z-index: 999;\n}\n\n.suggestionBoxWrapper {\n  width: 50%;\n  padding-left: 2rem;\n  justify-content: flex-start;\n  display: flex;\n  z-index: 100;\n  max-height: 0rem;\n}\n\n.searchBarWraper {\n  width: 95%;\n}\n\n.subNavSearch.open {\n  display: flex;\n  justify-content: center;\n  transition: var(--global-nav-transition);\n}\n\n@media (max-width: 740px) {\n  .navMain {\n    display: none;\n  }\n\n  .navMenu {\n    display: flex;\n  }\n\n  .globalNavContent {\n    display: flex;\n    justify-content: space-between;\n    width: 95%;\n    padding-left: 1.5rem;\n  }\n\n  .navLogo {\n    margin-left: -2rem;\n  }\n\n  .subNav.open {\n    display: flex;\n\n    transition: var(--global-nav-transition);\n  }\n}\n\n@media (max-width: 650px) {\n  .searchBarWraper {\n    width: 90%;\n  }\n\n  .subNavSearch {\n    height: 5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"globalNav": `PY5ioDyiOr48aM4MxjAh`,
	"globalNavContent": `dGwCJf3mYuSiyGWr13qY`,
	"navLogo": `Jsqyy0kFss3iM0YyiRxN`,
	"sticky": `GgNVO8vCuQZaDAYURklw`,
	"navMain": `kqkpJU8qPIsJ2vUpScLr`,
	"browse": `F4ujAmYUox73Q2BnHryG`,
	"navSearch": `J0T4aEd02ZDav5AVFNIu`,
	"navMenu": `W5ydC0Capn9X38iCyyUn`,
	"navSubscribe": `T3Pni6DossYKZRSaFoR_`,
	"subscribeButton": `Kg7VHnK58ALI9cgitdCi`,
	"subNav": `Rp8jTcpU1sjesdM_4aat`,
	"subNavSearch": `SbHssD3nS2uF0_4LhVvZ`,
	"stickySubNav": `qKq0K15EljkC7YtY1trK`,
	"stickySubNavSearch": `vf4PC6m9Q7rgi2YEP7b5`,
	"subNavSearchFixed": `miOdxh8RLqgnTaEtoCtw`,
	"suggestionBoxWrapper": `D6YwDzilEkC4mh5HOyuf`,
	"searchBarWraper": `KPh85AvIJKXiBfNNRkyR`,
	"open": `w8vnpG3ziJwwKPlURXRe`
};
export default ___CSS_LOADER_EXPORT___;
